import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import ConfirmDialog from 'components/ConfirmDialog';
import ExportDialog from 'components/ConfirmDialog/export';
import contentStyles from 'styles/contentArea';
import { FontIcon } from 'react-toolbox';
import PhaseExcelSheet from './PhaseExcelSheet';
// import { render } from 'react-dom';

const PhaseListHeader = (props) => {
  const {
    currentFilter,
    editFilter,
    title,
    deleteFilter,
    showConfirm,
    copyFilter,
    toggleModal,
    modalNumber,
    renderExcel,
    onProceed,
    unmountExcelSheet,
    loading,
    totalCount,
    phases,
  } = props;

  const formattedTitle = title + (!loading ? ` (${totalCount})` : '');
  let modal;
  if (modalNumber === 1) {
    modal = (
      <ConfirmDialog
        title={`Are you sure you want to delete
                      ${currentFilter && currentFilter.name ? currentFilter.name : 'this'}
                  filter?`}
        okLabel="Delete Filter"
        cancelLabel="Cancel"
        show={showConfirm}
        dismiss={() => {}}
        cancel={() => toggleModal(1)}
        proceed={deleteFilter}
      />
    );
  } else if (modalNumber === 2) {
    modal = (
      <ExportDialog
        title="What page would you like to export (per 1000 entries)?"
        okLabel="Export"
        cancelLabel="Cancel"
        show={showConfirm}
        dismiss={() => {}}
        cancel={() => toggleModal(2)}
        proceed={onProceed}
      />
    );
  } else {
    modal = null;
  }

  return (
    <div>
      <Helmet title={formattedTitle} />
      <h2 className={contentStyles.contentAreaTitle}>
        {formattedTitle}
        {currentFilter && (
          <div className={contentStyles.titleActions}>
            {renderExcel ? (
              <PhaseExcelSheet phases={phases} unmountExcelSheet={unmountExcelSheet} />
            ) : null}
            {
              <button onClick={() => toggleModal(2)} className={contentStyles.titleAction}>
                <FontIcon value="get_app" />
              </button>
            }
            {deleteFilter && (
              <button onClick={() => toggleModal(1)} className={contentStyles.titleAction}>
                <FontIcon value="delete" />
              </button>
            )}
            {copyFilter && (
              <button onClick={copyFilter} className={contentStyles.titleAction}>
                <FontIcon value="content_copy" />
              </button>
            )}
            {editFilter && (
              <button onClick={editFilter} className={contentStyles.titleAction}>
                <FontIcon value="mode_edit" />
              </button>
            )}
          </div>
        )}
        {modal}
      </h2>
    </div>
  );
};

PhaseListHeader.propTypes = {
  editFilter: PropTypes.func,
  copyFilter: PropTypes.func,
  deleteFilter: PropTypes.func,
  toggleModal: PropTypes.func,
  modalNumber: PropTypes.number,
  renderExcel: PropTypes.bool.isRequired,
  onProceed: PropTypes.func,
  unmountExcelSheet: PropTypes.func,
  currentFilter: PropTypes.object,
  showConfirm: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  totalCount: PropTypes.number,
  phases: PropTypes.array.isRequired,
};

export default PhaseListHeader;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/PhaseListHeader.jsx